import { Constants } from './../billing-page/billing-page.types';
import { ChangeDetectorRef, Component } from '@angular/core';
import { DatasetOption, LeftNavMenu, LeftNavMenuButton, TopRightMenuItem } from '@dxo/ng-swift-ui';
import { environment } from '@benefitsui/environments/environment';
import { UserContextService } from '../../services/user-context/user-context.service';
import { UserContext } from '../../services/user-context/user-context.types';
import { AuthenticationService } from '@benefitsui/app/services/auth/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FlagsService } from '@benefitsui/app/services/flags/flags.service';
import { FlatRouteEntry } from '@dxo/ng-swift-ui/lib/components/nav/components/side-nav/side-nav.types';
import { BehaviorSubject, combineLatest, map, Observable, of } from 'rxjs';
import { UserRole } from '@benefitsui/app/shared/enums/users';
import { Defaults } from '@benefitsui/app/shared/defaults/defaults';

@Component({
  selector: 'app-nav-portal-page',
  templateUrl: './left-nav-portal-page.component.html',
  styleUrls: ['./left-nav-portal-page.component.scss'],
  standalone: false,
  providers: [UserContextService]
})
export class LeftNavPortalPageComponent {
  //constants
  Benefits = 'Benefits';
  LogOut = 'Log out';
  ProfileSettings = 'Profile Settings';
  PartnerPortal = 'Partner Portal';
  ContactUs = 'Contact Us';
  LogoHref = environment.redirectUrl;
  PartnerPortalUrl = environment.partnerPortalUrl;
  ProfileSettingsUrl = environment.profileSettingsUrl;

  constructor(
    private authService: AuthenticationService,
    private userContextService: UserContextService,
    private router: Router,
    private flagsService: FlagsService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
    this.userContext = this.userContextService.get();
    this.userFullName = this.userContext.currentUserFullName;
    this.userType = this.userContext.symClass;
    switch (this.userContext.symClass.toLowerCase()) {
      case 'employee':
        this.userRole = UserRole.Employee;
        break;
      case 'distributor':
        this.userRole = UserRole.Broker;
        break;
      case 'sponsor':
        this.userRole = UserRole.Sponsor;
        break;
      default:
        this.userRole = UserRole.Sponsor;
        break;
    }
    this.logoText = 'benefits';

    this.mobileButtonsEmployee = [
      {
        label: this.PartnerPortal,
        onClick: () => this.goPartnerPortal()
      },
      {
        label: this.ContactUs,
        onClick: () => this.goContactUsPage()
      },
      {
        label: this.LogOut,
        icon: 'lock',
        onClick: () => this.logout()
      }
    ];
    this.mobileButtonsBroker = [
      {
        label: this.ProfileSettings,
        icon: 'settings',
        onClick: () => this.goProfileSettings()
      },
      {
        label: this.PartnerPortal,
        onClick: () => this.goPartnerPortal()
      },
      {
        label: this.ContactUs,
        onClick: () => this.goContactUsPage()
      },
      {
        label: this.LogOut,
        icon: 'lock',
        onClick: () => this.logout()
      }
    ];
    this.mobileButtonsPolicy = [
      {
        label: this.ProfileSettings,
        icon: 'settings',
        onClick: () => this.goProfileSettings()
      },
      {
        label: this.ContactUs,
        onClick: () => this.goContactUsPage()
      },
      {
        label: this.LogOut,
        icon: 'lock',
        onClick: () => this.logout()
      }
    ];

    this.topRightMenuEmployee = [
      {
        label: this.PartnerPortal,
        icon: {
          name: Defaults.stringEmpty
        },
        onClick: () => this.goPartnerPortal()
      },
      {
        label: this.ContactUs,
        icon: {
          name: ''
        },
        onClick: () => this.goContactUsPage()
      },
      {
        label: this.LogOut,
        icon: {
          name: 'lock'
        },
        onClick: () => this.logout()
      }
    ];

    this.topRightMenuPolicy = [
      {
        label: this.ProfileSettings,
        icon: {
          name: ''
        },
        onClick: () => this.goProfileSettings()
      },
      {
        label: this.ContactUs,
        icon: {
          name: ''
        },
        onClick: () => this.goContactUsPage()
      },
      {
        label: this.LogOut,
        icon: {
          name: 'lock'
        },
        onClick: () => this.logout()
      }
    ];

    this.topRightMenuBroker = [
      {
        label: this.PartnerPortal,
        icon: {
          name: ''
        },
        onClick: () => this.goPartnerPortal()
      },
      {
        label: this.ProfileSettings,
        icon: {
          name: ''
        },
        onClick: () => this.goProfileSettings()
      },
      {
        label: this.ContactUs,
        icon: {
          name: ''
        },
        onClick: () => this.goContactUsPage()
      },
      {
        label: this.LogOut,
        icon: {
          name: 'lock'
        },
        onClick: () => this.logout()
      }
    ];

    switch (this.userType.toLowerCase()) {
      case UserRole.Employee:
        this.topRightMenu = this.topRightMenuEmployee;
        this.mobileButtons = this.mobileButtonsEmployee;
        break;
      case UserRole.Broker:
        this.topRightMenu = this.topRightMenuBroker;
        this.mobileButtons = this.mobileButtonsBroker;
        break;
      case UserRole.Sponsor:
        this.topRightMenu = this.topRightMenuPolicy;
        this.mobileButtons = this.mobileButtonsPolicy;
        break;
      default:
        this.topRightMenu = this.topRightMenuEmployee;
        this.mobileButtons = this.mobileButtonsEmployee;
        break;
    }

    this.topRightMenu.filter((x) => !!x) as TopRightMenuItem[];
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  goContactUsPage() {
    this.router.navigate(['benefits/contacts'], { queryParamsHandling: 'preserve' });
    this.scrollToTop();
  }

  ngOnInit() {
    this.initializeFlags();
    this.setLeftNavMenu();
    this.cdr.detectChanges();
  }

  initializeFlags() {
    this.isAdmin.next(this.userContext.policyholderInfo?.isAdmin ?? false);
    this.isBasic.next(this.userContext.symEmployeeInfo?.isBasic ?? false);
    this.hasListBill = this.flagsService.subscribeToFlag('HASLISTBILL');
    this.showBilling = this.flagsService.subscribeToFlag('SHOW_BILLINGS');
    this.showClaim = this.flagsService.subscribeToFlag('SHOW_CLAIMS');
    this.showDocuments = this.flagsService.subscribeToFlag('SHOW_DOCUMENTS');
    this.showEOI = this.flagsService.subscribeToFlag('SHOW_EOI');
    this.showInsured = this.flagsService.subscribeToFlag('SHOW_INSURED');
    this.showScheduleA = this.flagsService.subscribeToFlag('SHOW_SCHEDULEA');
        this.showManageInsured = combineLatest([this.showInsured, this.hasListBill]).pipe(
      map(([showInsured, hasListBill]: [boolean, boolean]) => showInsured && hasListBill)
    );

    switch (this.userType.toLowerCase()) {
      case UserRole.Sponsor:
        this.showEmployeePages = combineLatest([this.isAdmin, this.hasListBill]).pipe(
          map(([isAdmin, hasListBill]: [boolean, boolean]) => isAdmin && hasListBill)
        );
        this.showEmployeeTab = combineLatest([this.showEOI, this.showEmployeePages]).pipe(
          map(([showEOI, showEmployeePages]) => showEOI || showEmployeePages)
        );
        break;

      case UserRole.Broker:
        this.showEmployeePages = this.hasListBill;
        this.showEmployeeTab = new BehaviorSubject<boolean>(true);
        break;

      case UserRole.Employee:
        this.showEmployeePages = combineLatest([this.isBasic, this.hasListBill]).pipe(
          map(([isBasic, hasListBill]: [boolean, boolean]) => isBasic && hasListBill)
        );
        this.showEmployeeTab = this.isBasic;
        break;

      default:
        this.showEmployeePages = new BehaviorSubject<boolean>(false);
    }
  }

  // :  Data members
  hasListBill = new BehaviorSubject<boolean>(false);
  showBilling = new BehaviorSubject<boolean>(false);
  showClaim = new BehaviorSubject<boolean>(false);
  showDocuments = new BehaviorSubject<boolean>(false);
  showEOI = new BehaviorSubject<boolean>(false);
  showInsured = new BehaviorSubject<boolean>(false);
  showScheduleA = new BehaviorSubject<boolean>(false);
  isAdmin = new BehaviorSubject<boolean>(false);
  isBasic = new BehaviorSubject<boolean>(false);
  showEmployeeTab!: Observable<boolean>;
  showEmployeePages!: Observable<boolean>;
  showManageInsured!: Observable<boolean>;
  policyToken = new BehaviorSubject<string>(Constants.StringEmpty);
  menu?: LeftNavMenu;
  mobileButtons: LeftNavMenuButton[] = [];
  mobileButtonsEmployee: LeftNavMenuButton[] = [];
  mobileButtonsBroker: LeftNavMenuButton[] = [];
  mobileButtonsPolicy: LeftNavMenuButton[] = [];
  topRightMenu: TopRightMenuItem[] = [];
  topRightMenuPolicy: TopRightMenuItem[] = [];
  topRightMenuBroker: TopRightMenuItem[] = [];
  topRightMenuEmployee: TopRightMenuItem[] = [];
  accountMenuItems: FlatRouteEntry[] = [];
  logoText: string;
  userContext: UserContext;
  userFullName: string;
  userType: string;
  userRole: UserRole;
  initialCountdown: number = environment.countdownSeconds;

  logoutDatasetData: DatasetOption['data'] = {
    name: 'Logout'
  };
  logoutDataset: DatasetOption[] = [
    { data: this.logoutDatasetData },
    { selector: 'span,div,dxo-icon', data: this.logoutDatasetData }
  ];

  logout() {
    this.authService.logout();
  }

  isBroker(): boolean {
    return this.userRole === UserRole.Broker;
  }

  isSponsor(): boolean {
    return this.userRole === UserRole.Sponsor;
  }

  isEmployee(): boolean {
    return this.userRole === UserRole.Employee;
  }

  goProfileSettings() {
    window.open(this.ProfileSettingsUrl);
  }

  goPartnerPortal() {
    window.open(this.PartnerPortalUrl);
  }

  setLeftNavMenu() {
    this.menu = {
      mobileButtons: this.mobileButtons,
      levelOne: [
        {
          label: 'Back to Groups',
          href: '/benefits/search',
          icon: 'arrow_back',
          visible$: of(this.isEmployee() || this.isBroker())
        },
        {
          label: 'Dashboard',
          icon: 'dashboard',
          routerLink: '/benefits/dashboard',
          queryParamsHandling: 'preserve',
          visible$: of(environment.routeFlags.showDashboard ?? true)
        },
        {
          label: 'Financial',
          expanded: false,
          visible$: combineLatest([this.showBilling, of(environment.routeFlags.showFinancial ?? true)]).pipe(
            map(([showBilling, showFinancial]) => showBilling && showFinancial)
          ),
          levelTwo: [
            {
              label: 'Billing',
              routerLink: '/benefits/billing',
              queryParamsHandling: 'preserve',
              visible$: of(environment.routeFlags.showBillingStandard ?? true),
              routerLinkActiveOptions: {
                matrixParams: 'exact',
                queryParams: 'ignored',
                paths: 'subset',
                fragment: 'ignored'
              }
            },
            {
              label: 'Billing (Fancy)',
              routerLink: '/benefits/billing-statements',
              queryParamsHandling: 'preserve',
              visible$: of(environment.routeFlags.showBillingFancy ?? true),
              routerLinkActiveOptions: {
                matrixParams: 'exact',
                queryParams: 'ignored',
                paths: 'subset',
                fragment: 'ignored'
              }
            },
            {
              label: 'Tax Forms',
              // @ts-expect-error need this so we can specify the tab to select by default w/o query parameters
              routerLink: ['/benefits/redirect/forms', { tab: 'tax' }],
              routerLinkActiveOptions: { exact: false },
              queryParamsHandling: 'preserve',
              visible$: of(environment.routeFlags.showTaxForms ?? true)
            }
          ]
        },
        {
          label: 'Employees',
          expanded: false,
          visible$: this.showEmployeeTab,
          levelTwo: [
            {
              label: 'Employee Center',
              routerLink: '/benefits/employees',
              queryParamsHandling: 'preserve',
              visible$: combineLatest([
                this.showEmployeePages,
                of(environment.routeFlags.showSearchEmployees ?? true)
              ]).pipe(map(([showPages, showFlag]) => showPages && showFlag))
            },
            {
              label: 'Add Employee',
              routerLink: '/benefits/employees/add',
              queryParamsHandling: 'preserve',
              visible$: combineLatest([
                this.showEmployeePages,
                of(environment.routeFlags.showAddEmployee ?? true)
              ]).pipe(map(([showPages, showFlag]) => showPages && showFlag))
            },
            {
              label: 'EOI Report',
              routerLink: '/benefits/report',
              queryParamsHandling: 'preserve',
              visible$: combineLatest([this.showEOI, of(environment.routeFlags.showEOIReport ?? true)]).pipe(
                map(([showEOI, showFlag]) => showEOI && showFlag)
              )
            },
            {
              label: 'Employee Forms',
              // @ts-expect-error need this so we can specify the tab to select by default w/o query parameters
              routerLink: ['/benefits/redirect/forms', { tab: 'employee' }],
              routerLinkActiveOptions: { exact: false },
              queryParamsHandling: 'preserve',
              visible$: of(environment.routeFlags.showEmployeeForms ?? true)
            }
          ]
        },
        {
          label: 'Claims',
          expanded: false,
          visible$: combineLatest([this.showClaim, of(environment.routeFlags.showClaims ?? true)]).pipe(
            map(([showClaim, showClaimsFlag]) => showClaim && showClaimsFlag)
          ),
          levelTwo: [
            {
              label: 'Claims Center',
              routerLink: '/benefits/claims',
              queryParamsHandling: 'preserve',
              visible$: of(environment.routeFlags.showClaimsSearch ?? true)
            },
            {
              label: 'Create New Claim',
              routerLink: '/benefits/claims/create',
              queryParamsHandling: 'preserve',
              visible$: of(environment.routeFlags.showCreateClaims ?? true)
            },
            {
              label: 'Claim Reports',
              routerLink: '/benefits/claims/report',
              queryParamsHandling: 'preserve',
              visible$: of(environment.routeFlags.showClaimReports ?? true)
            },
            {
              label: 'Claim Forms',
              // @ts-expect-error need this so we can specify the tab to select by default w/o query parameters
              routerLink: ['/benefits/redirect/forms', { tab: 'claims' }],
              routerLinkActiveOptions: { exact: false },
              queryParamsHandling: 'preserve',
              visible$: of(environment.routeFlags.showClaimForms ?? true)
            }
          ]
        },
        {
          label: 'Resources',
          expanded: false,
          visible$: of(environment.routeFlags.showResources ?? true),
          levelTwo: [
            {
              label: 'Contract Documents',
              routerLink: '/benefits/documents',
              queryParamsHandling: 'preserve',
              visible$: of(environment.routeFlags.showContractDocuments ?? true)
            },
            {
              label: 'Forms',
              routerLink: '/benefits/allforms',
              queryParamsHandling: 'preserve',
              visible$: of(environment.routeFlags.showAllForms ?? true),
              routerLinkActiveOptions: {
                matrixParams: 'exact',
                queryParams: 'ignored',
                paths: 'subset',
                fragment: 'ignored'
              }
            }
          ]
        }
      ]
    };
  }
}
